<template>
<div :class="$options.name" ref="homeWrapper">
    <full-page
        ref="fullpage" 
        :options="options"
        :skip-init="true"
    >
        <div class="intro section">
            <div :class="['intro-container', portraitMode ? '-bottom' : '-v-centered']">
                <h1 :class="['heading -xxl', portraitMode ? '-portrait' : '-landscape']">
                    <span class="name">Katy</span>   
                    <span class="name">Dattoma</span>    
                </h1>
                <h2 :class="['heading -l entrance', , portraitMode ? '-portrait' : '-landscape']">
                    Front-End Developer
                </h2>
            </div>
            <button
                @click="scrollDown"
                ref="scroll"
                class="scroll"
            >
                <scroll-down-icon class="animate-up-down" :color="'white'" />
            </button>
        </div>
        <about-me class="section" />
        <template v-for="(project, index) in projectsList">
            <preview-project
                :key="project.slug"
                :index="index" 
                :project="project" 
                :class="['section']" 
            />
        </template>
        <contact-me class="section" />
    </full-page>
</div>
</template>

<script>

import _ from 'lodash'
import chroma from 'chroma-js'
import { mapGetters } from 'vuex'
import AboutMe from '@/components/AboutMe'
import ContactMe from '@/components/Contact'
import ScrollDownIcon from '@/components/ScrollDownIcon'
import PreviewProject from '@/components/PreviewProject'

export default {
    name: 'home',
    data() {
        return {
            tl: false,
            options: {
                afterLoad: (origin, destination, direction) => {
                    this.sendBusEvent({origin, destination, direction})
                },
                anchors: [],
                navigation: true,
                navigationTooltips: [
                    'Intro',
                    'About me',
                    'DQ',
                    'Yourselfie',
                    'Alexa',
                    'GPS',
                    'Contact'
                ],
                keyboardScrolling: true,
                animateAnchor: true,
                recordHistory: true,
                navigationPosition: 'right',
                licenseKey: 'C7911E85-568942AD-B15FAD88-BB25026D'
            }
        }
    },
    components: {
        'about-me': AboutMe,
        'contact-me': ContactMe,
        'preview-project': PreviewProject,
        'scroll-down-icon': ScrollDownIcon
    },
    computed: {
        ...mapGetters({
            bgColors: 'bgColors',
            themeColor: 'themeColor',
            sectionClicked: 'sectionClicked',
            getFullPageApi: 'getFullPageApi',
            deviceOrientation: 'deviceOrientation',
            homePageSections: 'getHomePageSections'
        })
    },
    watch: {
        deviceOrientation: {
            handler: function(now, before) {
                this.destroyFullpage()
                this.$nextTick(() => {
                    this.initFullPageScroll()
                })
            }
        }
    },
    mounted() {
        this.initFullPageScroll()
    },
    methods: {
        initFullPageScroll() {
            this.options.anchors = this.homePageSections
            this.$refs.fullpage.init()
            this.$store.dispatch('setFullPageApi', fullpage_api)
            if (this.sectionClicked) {
                fullpage_api.moveTo(this.sectionClicked)
                this.$store.dispatch('updateSectionClicked', false)
            }
        },
        scrollDown() {
            fullpage_api.moveSectionDown()
        },
        sendBusEvent(payload) {
            this.changeBgColor(payload.destination.index)
            this.$bus.$emit(this.$bus.SCROLLING_PROJECTS, payload)
        },
        changeBgColor(index) {
            let color = (index > 1 && index < this.homePageSections.length - 1) ? this.bgColors[index] : '#ffffff'
            this.$store.dispatch('saveThemeColor', color)
            document.documentElement.style.setProperty('--bg-color', `${this.bgColors[index]}`)
            document.documentElement.style.setProperty('--darker-color', `${chroma(this.bgColors[index]).darken()}`)
        },
        destroyFullpage() {
            fullpage_api.destroy('all')
            this.$store.dispatch('setFullPageApi', false)
        }
    },
    beforeDestroy() {
        this.destroyFullpage()
    }
}
</script>
<style lang="scss" scoped>

.home {
    color: $white;
    height: 100vh;
    position: relative;
    height: calc(var(--vh, 1vh) * 100);
    .intro {
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: relative;
    }
    .intro-container {
        display: flex;
        overflow: hidden;
        position: relative;
        flex-direction: column;
        &.-v-centered {
            width: 100%;
            height: 100%;
            justify-content: center;
        }
        &.-bottom {
            width: 100%;
            bottom: 20vh;
            position: absolute;
            transform: translate3d(0, 0, 0);
            @include g-state(tablet) {
                bottom: 15vh;
            }
        }
        
        .heading {
            padding-left: 1rem;
            @include g-state(tablet) {
                padding-left: 3rem;
            }
            &.-xxl {
                .name {
                    display: block;
                    text-shadow: 6px 6px 0 var(--darker-color);
                }
            }
        }
    }
    .scroll {
        left: 50%;
        bottom: 1rem;
        width: 2.8rem;
        position: fixed;
        transform: translateX(-50%);
    }
    .animate-up-down {
        animation: up-down 0.5s cubic-bezier(0.5, 0.2, 0.3, 1.0) alternate infinite;
    }
}
@keyframes up-down {
    from {
        transform: translateY(0%);
    }
    to {
        transform: translateY(10%);
    }
}
</style>